import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { ProductType } from '../_models/product_type';

@Injectable({
  providedIn: 'root',
})
export class ProductTypesService {
  constructor(private http: HttpClient) {}

  getAllProductTypes() {
    return this.http
      .get<ProductType[]>(`${environment.apiUrl}/api/product_types`)
      .pipe(
        map((responseData) => {
          return responseData;
        })
      );
  }

  deleteProductType(productTypeId: number) {
    return this.http.delete(
      `${environment.apiUrl}/api/product_types/${productTypeId}`
    );
  }

  updateProductType(pTypeId: number, productType: ProductType) {
    return this.http.patch<ProductType>(
      `${environment.apiUrl}/api/product_types/${pTypeId}`,
      productType
    );
  }

  addProductType(productTypes: ProductType[]) {
    return this.http.post<ProductType[]>(
      `${environment.apiUrl}/api/product_types`,
      productTypes
    );
  }

  uploadFile(pTypeId: number, file: any) {
    return this.http.patch<ProductType>(
      `${environment.apiUrl}/api/product-technical-documentations/${pTypeId}`,
      file
    );
  }
}
